import React from "react";

interface Props {
  title: string;
}

interface State {
  isExpanded: boolean;
  height: number;
}

class Collapsible extends React.Component<Props, State> {
  refs: {
    [string: string]: any;
    any: any;
  };

  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
      height: 0,
    };
  }

  handleToggle(e) {
    e.preventDefault();
    this.setState({
      isExpanded: !this.state.isExpanded,
      height: this.refs.inner.clientHeight,
    });
  }

  render() {
    const { title, children } = this.props;
    const { isExpanded, height } = this.state;
    const currentHeight = isExpanded ? height : 0;
    return (
      <div
        className={`collapsible ${isExpanded ? "is-expanded" : ""}`}
        onClick={(e) => this.handleToggle(e)}
      >
        <div className="collapsible-heading">
          <h2
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          <button className="btnToggle">
            Toggle section
            <span className="icon-plus">
              <span />
            </span>
          </button>
        </div>
        <div
          className="collapsible-collapse"
          style={{ height: currentHeight + "px" }}
        >
          <div className="collapsible-body" ref="inner">
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default Collapsible;
